import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.655 20.433a1 1 0 0 1-1.31 0l-5.112-4.427c-.7-.606-.27-1.756.655-1.756h10.224c.926 0 1.355 1.15.655 1.756zM11.345 3.567a1 1 0 0 1 1.31 0l5.112 4.427c.7.606.27 1.756-.655 1.756H6.888c-.926 0-1.355-1.15-.655-1.756z"
    }, null, -1)
  ]))]))
}
export default { render: render }